// 提供给子系统的工具
import { Modal } from 'ant-design-vue'
window.cupsheIframe = {
  Modal,

  openMask() {
    window.currentIframe.classList.add('modalIframe')
  },
  closeMask() {
    window.currentIframe.classList.remove('modalIframe')
  },
  // 支持子系统传url跳转页面
  toJump(url) {
    location.href =
      location.origin + `/Iframe?target=${encodeURIComponent(url)}`
  },
  // 添加页签
  /**
   *
   * @param {menuPath, menuName} param
   * @param {*} other
   */
  addBreadTags(param, other = {}) {
    window.store.commit(
      'user/saveHistoryRouter',
      {
        ...{
          data: param
        },
        ...other
      },
      {
        root: true
      }
    )
  }
}
